// Small pure policies for DI-1 (unsaved-work protection). They sit on top
// of the testing-foundation helpers in workspaceState.js and are kept
// separate so the rules can be unit-tested without React.
import { isMeaningfulEntry, isWorkspaceMeaningful } from "./workspaceState";

// True when the workspace is a single activity tab that is not part of a
// session (no session id, name or details). Only then does saving (or
// loading) that ONE activity make the whole workspace "saved" — otherwise
// the other tabs / session details would still be unsaved.
export function isSingleActivityWorkspace({ tabs, sessionId, sessionName, sessionMeta } = {}) {
  return (
    Array.isArray(tabs) &&
    tabs.length === 1 &&
    !sessionId &&
    !isWorkspaceMeaningful({ tabs: [], sessionName, sessionMeta })
  );
}

// Loading a Library activity replaces only the ACTIVE tab, so it needs a
// confirmation only when that tab holds work and that work is unsaved.
export function shouldConfirmReplaceActiveTab({ activeEntry, hasUnsavedWork }) {
  return Boolean(hasUnsavedWork) && isMeaningfulEntry(activeEntry);
}
